import { useState } from "react";
import { Download, Search, Trash2 } from "lucide-react";
import { formatDate } from "@/lib/api";

const toCsv = (rows) => {
  const head = ["Posizione", "Nome", "Email", "Telefono", "Fonte", "Data"];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = rows.map((r) => [r.posizione, r.nome, r.email, r.telefono, r.fonte, formatDate(r.created_at)].map(esc).join(";"));
  return "\uFEFF" + [head.join(";"), ...lines].join("\n");
};

const download = (rows) => {
  const blob = new Blob([toCsv(rows)], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `mimis-lista-attesa-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const Table = ({ cols, rows, empty, testId, render }) => (
  <div className="overflow-x-auto rounded-2xl border border-[#e7e7ea] bg-white" data-testid={testId}>
    <table className="w-full min-w-[640px] text-left text-sm">
      <thead className="bg-[#F5F5F7] text-xs uppercase tracking-wider text-[#52525b]">
        <tr>{cols.map((c) => <th key={c} className="px-4 py-3 font-semibold">{c}</th>)}</tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr><td colSpan={cols.length} className="px-4 py-12 text-center text-[#52525b]">{empty}</td></tr>
        ) : rows.map(render)}
      </tbody>
    </table>
  </div>
);

export const WaitlistTable = ({ rows, onDelete }) => {
  const [q, setQ] = useState("");
  const list = Array.isArray(rows) ? rows : [];
  const filtered = list.filter((r) => `${r.nome} ${r.email} ${r.telefono}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <label className="relative w-full sm:max-w-xs">
          <Search className="absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#71717a]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca nome, email, telefono" className="h-11 w-full rounded-full border border-[#e2e2e6] bg-white pl-10 pr-4 text-sm outline-none focus:border-[#0066FF]" data-testid="admin-waitlist-search" />
        </label>
        <button onClick={() => download(filtered)} className="btn-ghost h-11 px-5 text-sm" data-testid="admin-export-csv-button">
          <Download className="h-4 w-4" /> Esporta CSV
        </button>
      </div>
      <Table
        testId="admin-waitlist-table"
        cols={["#", "Nome", "Email", "Telefono", "Fonte", "Data", ""]}
        rows={filtered}
        empty="Ancora nessun iscritto. Condividi getmimis.com!"
        render={(r) => (
          <tr key={r.id} className="border-t border-[#f0f0f2] hover:bg-[#fafafa]" data-testid={`waitlist-row-${r.id}`}>
            <td className="px-4 py-3 font-semibold text-[#0066FF]">{r.posizione}</td>
            <td className="px-4 py-3 font-medium">{r.nome}</td>
            <td className="px-4 py-3"><a href={`mailto:${r.email}`} className="hover:text-[#0066FF]">{r.email}</a></td>
            <td className="px-4 py-3"><a href={`tel:${r.telefono}`} className="hover:text-[#0066FF]">{r.telefono}</a></td>
            <td className="px-4 py-3 text-[#52525b]">{r.fonte}</td>
            <td className="px-4 py-3 text-[#52525b]">{formatDate(r.created_at)}</td>
            <td className="px-4 py-3 text-right">
              <button onClick={() => onDelete(r)} className="rounded-full p-2 text-[#71717a] transition-colors hover:bg-red-50 hover:text-red-600" aria-label="Elimina" data-testid={`waitlist-delete-${r.id}`}><Trash2 className="h-4 w-4" /></button>
            </td>
          </tr>
        )}
      />
    </div>
  );
};
